"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
function isRgbItem(input) {
    return typeof input === 'object' &&
        ['r', 'g', 'b'].every(function (x) { return Object.keys(input).indexOf(x) !== -1; });
}
exports.isRgbItem = isRgbItem;
function isRgbItemList(input) {
    return Array.isArray(input) && input.length > 0 && input.every(function (x) { return isRgbItem(x); });
}
exports.isRgbItemList = isRgbItemList;
